import { render, staticRenderFns } from "./AreaTreeCard.vue?vue&type=template&id=96b5663a&scoped=true"
import script from "./AreaTreeCard.vue?vue&type=script&lang=js"
export * from "./AreaTreeCard.vue?vue&type=script&lang=js"
import style0 from "./AreaTreeCard.vue?vue&type=style&index=0&id=96b5663a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96b5663a",
  null
  
)

export default component.exports